import { PipeTransform, Pipe } from '@angular/core';
import momentImported from 'moment';
const moment = momentImported;

@Pipe({
    name: 'wafDateTime',
    standalone: false
})
export class DateTimeStringPipe implements PipeTransform {

    private static readonly ISO8601 = 'YYYY-MM-DD HH:mm';

    transform(value: any, pattern?: string) {

        if (value) {
            const momentObj = moment(value, DateTimeStringPipe.ISO8601);

            if (pattern) {
                return momentObj.format(pattern);
            }
            else {
                const dateString = momentObj.format('L');
                const timeString = momentObj.format('LT');

                return dateString + ' ' + timeString;
            }
        }

        return '';
    }
}